import script from "./AdminForumManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminForumManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminForumManager.vue?vue&type=style&index=0&id=bfa0a130&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa0a130"]])

export default __exports__